module.exports = __webpack_public_path__ + "img/md0desc.80cf3f6c.png";